const api = {
  GET_LIST_HISTORY_INSERT_FILE_TRANSACTION: '/index.php?r=api/v1/history_approval/off-us/history-trx-file',
  DOWNLOAD_RESULT_INSERT_FILE_OFF_US: '/index.php?r=api/v1/history_approval/off-us/download-file'
};

export default api;
